document.addEventListener('DOMContentLoaded', function () {
  const firstItems = document.querySelectorAll('.level-1-item');
  const secondWrappers = document.querySelectorAll('.level-2-wrapper');
  const thirdItems = document.querySelectorAll('.level-3-item');

  let thirdSubmenuTimeout;
  let fourthSubmenuTimeout;

  firstItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      const index = item.getAttribute('data-index');

      document.querySelectorAll('.level-2-submenu').forEach(sub => {
        sub.classList.remove('active');
        if (sub.getAttribute('data-parent') === index) {
          sub.classList.add('active');
        }
      });

      document.querySelectorAll('.level-3-submenu, .level-4-submenu').forEach(sub => sub.classList.remove('active'));
    });
  });

  secondWrappers.forEach(wrapper => {
    const index = wrapper.getAttribute('data-index');
    const thirdMenu = document.querySelector(`.level-3-submenu[data-parent="${index}"]`);

    wrapper.addEventListener('mouseenter', () => {
      clearTimeout(thirdSubmenuTimeout);
      document.querySelectorAll('.level-3-submenu').forEach(sub => sub.classList.remove('active'));
      if (thirdMenu) thirdMenu.classList.add('active');
      document.querySelectorAll('.level-4-submenu').forEach(sub => sub.classList.remove('active'));
    });

    wrapper.addEventListener('mouseleave', () => {
      thirdSubmenuTimeout = setTimeout(() => {
        if (thirdMenu) thirdMenu.classList.remove('active');
      }, 200);
    });

    if (thirdMenu) {
      thirdMenu.addEventListener('mouseenter', () => {
        clearTimeout(thirdSubmenuTimeout);
        thirdMenu.classList.add('active');
      });

      thirdMenu.addEventListener('mouseleave', () => {
        thirdSubmenuTimeout = setTimeout(() => {
          thirdMenu.classList.remove('active');
        }, 200);
      });
    }
  });

  thirdItems.forEach(item => {
    const thirdSubmenu = item.closest('.level-3-submenu');
    const parentIndex = thirdSubmenu.getAttribute('data-parent');
    const index = `${parentIndex}-${[...item.parentNode.children].indexOf(item)}`;
    const fourthMenu = document.querySelector(`.level-4-submenu[data-parent="${index}"]`);

    item.addEventListener('mouseenter', () => {
      clearTimeout(fourthSubmenuTimeout);
      clearTimeout(thirdSubmenuTimeout);
      document.querySelectorAll('.level-4-submenu').forEach(sub => sub.classList.remove('active'));
      if (fourthMenu) fourthMenu.classList.add('active');
    });

    item.addEventListener('mouseleave', () => {
      fourthSubmenuTimeout = setTimeout(() => {
        if (fourthMenu) fourthMenu.classList.remove('active');
      }, 200);
    });

    if (fourthMenu) {
      fourthMenu.addEventListener('mouseenter', () => {
        clearTimeout(fourthSubmenuTimeout);
        clearTimeout(thirdSubmenuTimeout); 
        fourthMenu.classList.add('active');
        if (thirdSubmenu) thirdSubmenu.classList.add('active');
      });
      fourthMenu.addEventListener('mouseleave', () => {
        fourthSubmenuTimeout = setTimeout(() => {
          fourthMenu.classList.remove('active');
          if (thirdSubmenu) thirdSubmenu.classList.remove('active');
        }, 200);
      });
    }
  });

  const nav = document.querySelector('.custom_meganavigation--version-b');
  nav.addEventListener('mouseleave', () => {
    document.querySelectorAll('.submenu').forEach(sub => sub.classList.remove('active'));
  });
});